"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((item, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted-foreground/10 animate-pulse rounded-sm" />)}
      </div>;
  }
  const itemsToRender = menuItems.length > 0 ? menuItems : [{
    id: "home",
    label: "Home",
    href: "/"
  }, {
    id: "protocolos",
    label: "Protocolos",
    href: "/protocolos"
  }, {
    id: "clinica",
    label: "A Clínica",
    href: "/a-clinica"
  }, {
    id: "agendamento",
    label: "Agendamento",
    href: "/agendamento"
  }];
  return <nav className="flex flex-col gap-3">
      {itemsToRender.map((item, i) => <Link key={item.id || i} to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium w-fit" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Rodape() {
  const currentYear = new Date().getFullYear();
  return <section id="rodapé" className="bg-muted/30 pt-16 pb-8 border-t border-border/40">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/dil_saude_capilar_logo.png" alt="Dil Saúde Capilar" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Especializada em tricologia e terapia capilar feminina. Unimos tecnologia avançada e cuidado humanizado para promover saúde, bem-estar e autoestima através de resultados visíveis e duradouros.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-serif text-lg font-semibold tracking-tight">
              Links Rápidos
            </h3>
            <MenuProvider menu_id="47" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-serif text-lg font-semibold tracking-tight">
              Contato
            </h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>
                  Rua das Flores, 123 - Centro,
                  <br />
                  Cidade, Estado, CEP 00000-000
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 text-primary shrink-0" />
                <Link to="tel:+5511912345678" className="hover:text-primary transition-colors">
                  (11) 91234-5678
                </Link>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:contato@dilsaudecapilar.com.br" className="hover:text-primary transition-colors">
                  contato@dilsaudecapilar.com.br
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-serif text-lg font-semibold tracking-tight">
              Horário de Atendimento
            </h3>
            <div className="flex items-start gap-3 text-sm text-muted-foreground mb-4">
              <Clock className="size-5 text-primary shrink-0 mt-0.5" />
              <div className="flex flex-col gap-1">
                <span>Segunda a Sexta: 09h00 às 18h00</span>
                <span>Sábados: Sob agendamento</span>
              </div>
            </div>
            
            <div className="flex flex-col gap-3">
              <h4 className="text-sm font-medium text-foreground">Siga-nos</h4>
              <div className="flex items-center gap-3">
                <Button variant="outline" size="icon" className="rounded-full hover:bg-primary hover:text-primary-foreground border-primary/20 transition-colors" asChild>
                  <Link to="#" aria-label="Instagram" newTab>
                    <Instagram className="size-4" />
                  </Link>
                </Button>
                <Button variant="outline" size="icon" className="rounded-full hover:bg-primary hover:text-primary-foreground border-primary/20 transition-colors" asChild>
                  <Link to="#" aria-label="Facebook" newTab>
                    <Facebook className="size-4" />
                  </Link>
                </Button>
                <Button variant="outline" size="icon" className="rounded-full hover:bg-primary hover:text-primary-foreground border-primary/20 transition-colors" asChild>
                  <Link to="#" aria-label="LinkedIn" newTab>
                    <Linkedin className="size-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-border/60" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 text-xs text-muted-foreground/80">
          <p>
            &copy; {currentYear} Dil Saúde Capilar. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="font-medium text-primary/80">Designed for Wellness</span>
            <Link to="/politica-de-privacidade" className="hover:text-primary transition-colors">
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </section>;
}